import React, { useContext, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AppContext } from '../context/AppContext';
import { createRoomAPI, joinRoomAPI } from '../services/api';

const DashboardPage = () => {
  const { user, recordings } = useContext(AppContext);
  const navigate = useNavigate();
  const [joinRoomCode, setJoinRoomCode] = useState('');
  const [loadingStart, setLoadingStart] = useState(false);
  const [loadingJoin, setLoadingJoin] = useState(false);

  const startNewClass = async () => {
    setLoadingStart(true);
    try {
      const room = await createRoomAPI(user.id);
      navigate(`/live-class/${room.room_code}`);
    } catch (err) {
      console.error(err);
      alert('Error creating room: ' + err.message);
    } finally {
      setLoadingStart(false);
    }
  };

  const handleJoinRoom = async (e) => {
    e.preventDefault();
    const code = joinRoomCode.trim().toUpperCase();
    if (!code) {
      alert('Please enter a room code.');
      return;
    }
    setLoadingJoin(true);
    try {
      await joinRoomAPI(code, user.id);
      navigate(`/live-class/${code}`);
    } catch (err) {
      console.error(err);
      alert('Error joining room: ' + err.message);
    } finally {
      setLoadingJoin(false);
    }
  };

  return (
    <div>
      <h3 className="mb-3">Welcome, {user.name}</h3>
      <div className="row g-3">
        {/* Start New Class (Teacher) */}
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <h5>Start a New Live Class</h5>
              <p className="text-muted">
                Create a new live class room with audio, video, screen share & chat.
              </p>
              <button className="btn btn-primary" onClick={startNewClass} disabled={loadingStart}>
                {loadingStart ? 'Creating...' : 'Start New Live Class'}
              </button>
            </div>
          </div>
        </div>

        {/* Join Existing Class (Student) */}
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <h5>Join a Live Class</h5>
              <p className="text-muted">
                Enter the room code shared by your trainer and click Join.
              </p>
              <form onSubmit={handleJoinRoom}>
                <div className="input-group">
                  <input
                    className="form-control"
                    placeholder="Enter Room Code (e.g., ABC123)"
                    value={joinRoomCode}
                    onChange={(e) => setJoinRoomCode(e.target.value)}
                  />
                  <button className="btn btn-success" type="submit" disabled={loadingJoin}>
                    {loadingJoin ? 'Joining...' : 'Join'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Recordings Card */}
        <div className="col-md-4 mt-3">
          <div className="card h-100">
            <div className="card-body">
              <h5>Recordings</h5>
              <p className="text-muted">
                You currently have <strong>{recordings.length}</strong> recordings (from PHP API).
              </p>
              <Link to="/recordings" className="btn btn-outline-secondary btn-sm">
                Go to Recording List
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
